// Bar.js
import React from "react";
import styles from "./Bar.module.css";

const Bar = ({
  leftContent,
  centreContent,
  rightContent,
  className = "",
  leftClassName = "",
  centreClassName = "",
  rightClassName = "",
  ...rest
}) => {
  return (
    <div className={`${styles.bar} ${className}`.trim()} {...rest}>
      <div className={`${styles["bar-left"]} ${leftClassName}`.trim()}>
        {leftContent}
      </div>
      <div className={`${styles["bar-centre"]} ${centreClassName}`.trim()}>
        {centreContent}
      </div>
      <div className={`${styles["bar-right"]} ${rightClassName}`.trim()}>
        {rightContent}
      </div>
    </div>
  );
};

export default Bar;
